import { render, staticRenderFns } from "./wxpay.vue?vue&type=template&id=232875e1&scoped=true&"
import script from "./wxpay.vue?vue&type=script&lang=js&"
export * from "./wxpay.vue?vue&type=script&lang=js&"
import style0 from "./wxpay.vue?vue&type=style&index=0&id=232875e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232875e1",
  null
  
)

export default component.exports